<div mat-dialog-content>
    <p>{{data.title}}</p>
  </div>
  <div mat-dialog-actions fxLayout="column">

      <input multiple accept=".jpg, .png, .mp4" type="file" class="inputFile" (change)="onChange($event)" id="file" name="file">

    <section fxLayout='row'>

        <button mat-button cdkFocusInitial (click)="onNoClick($event)">{{'cancel' | translation}}</button>
        <button mat-raised-button color="accent" (click)="onImport()">{{'import' | translation}}</button>

    </section>

  </div>
